import {
  Button,
  DropdownPrimeReact,
  InputCurrency,
} from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  useCuentaContableCuentaIvaCompra,
  useCuentaContableCuentaIvaVenta,
} from "api/CuentaContable_Cuenta.hook"
import {
  useCuentaContableEmpresaIvaCompraModalAsientos,
  useCuentaContableEmpresaIvaVentaModalAsiento,
} from "api/CuentaContableEmpresa.hook"
import { GetAllImpuestosDtoProps } from "api/DTOs/GetAllImpuestosDto"
import { useImpuestoEmpresaAsientosContables } from "api/ImpuestoEmpresa.hook"
import { IMPUESTO_CATEGORIA } from "api/Types/ImpuestoCategoria"
import { SHOW_TAXES_COMPRAS } from "api/Types/TipoAsiento"
import DropdownCuentasAsientos from "common/components/DropdownsCuentasContables/DropdownCuentasAsientos/DropdownCuentasAsientos"
import { FieldArray, FormikHelpers } from "formik"
import { FormikErrors } from "interfaces/Formik"
import { useTranslation } from "react-i18next"
import { v4 as uuidv4 } from "uuid"
import {
  AsientoContableFormikProps,
  LineaImpuestoFormikProps,
} from "../../constant"

const LineasImpuestosAsientosContable = ({
  values,
  errors,
  setFieldValue,
}: {
  values: AsientoContableFormikProps
  errors: FormikErrors<AsientoContableFormikProps>
  setFieldValue: FormikHelpers<AsientoContableFormikProps>["setFieldValue"]
}) => {
  const { t } = useTranslation()
  const {
    cuentasContablesEmpresas: cuentasCompras,
    cuentasContablesEmpresasIsLoading: cuentasComprasIsLoading,
    cuentasContablesEmpresasRefetch: cuentasComprasRefetch,
  } = useCuentaContableEmpresaIvaCompraModalAsientos()

  const { cuentasContablesEmpresas: cuentasComprasBase } =
    useCuentaContableCuentaIvaCompra()
  const {
    cuentasContablesEmpresas: cuentasVenta,
    cuentasContablesEmpresasIsLoading: cuentasVentaIsLoading,
    cuentasContablesEmpresasRefetch: cuentasVentaRefetch,
  } = useCuentaContableEmpresaIvaVentaModalAsiento()

  const { cuentasContablesEmpresas: cuentasVentaBase } =
    useCuentaContableCuentaIvaVenta()

  const { impuestosEmpresa, impuestosEmpresaIsLoading } =
    useImpuestoEmpresaAsientosContables(values.tipoAsiento)

  return (
    <div className='tw-flex tw-flex-col tw-h-full tw-pt-6'>
      <div className='tw-px-7 tw-gap-2 tw-w-full tw-grid tw-grid-cols-4 tw-font-medium tw-mb-1 tw-text-sm'>
        <span className=''>{t("diario.modal.headerTaxes")}</span>
        <span className=' tw-text-start'>
          {t("diario.modal.headerAccountId")}
        </span>
        <span className=' tw-text-start'>
          {t("diario.modal.headerSubTotal")}
        </span>
        <span className=' tw-text-end tw-mr-11 tw-pr-5'>
          {t("diario.modal.headerTaxeValue")}
        </span>
      </div>

      <FieldArray name='lineasImpuesto'>
        {({ push, remove }) => {
          return (
            <div className='tw-w-full tw-px-5 tw-py-3 tw-bg-background tw-h-[calc(100%-24px)] tw-flex tw-flex-col tw-justify-between tw-rounded-md'>
              <div className='tw-flex tw-flex-col tw-flex-1 tw-h-[calc(100%-72px)] tw-overflow-y-auto'>
                {values.lineasImpuesto.map(
                  (impuesto: LineaImpuestoFormikProps, index: number) => (
                    <div
                      className='tw-gap-2 tw-bg-white tw-w-full tw-grid tw-grid-cols-4 tw-items-center tw-h-14 tw-p-2 tw-mb-2'
                      key={impuesto.id || index}
                    >
                      <div className='tw-h-full tw-col-span-1'>
                        <DropdownPrimeReact
                          placeholder={`${t(
                            "filtros.prestamo.placeholderSelectTaxe"
                          )}`}
                          pt={{
                            input: {
                              className: "!tw-text-sm ",
                            },
                          }}
                          options={impuestosEmpresa}
                          className={`tw-rounded !tw-border-neutral-25 ${
                            errors?.lineasImpuesto?.[index]?.porcentajeImpuesto
                              ? "!tw-border-danger"
                              : ""
                          } tw-h-full !tw-w-full !tw-text-sm hover:!tw-border-neutral-75`}
                          id={`${impuesto.id}-porcentajeImpuesto`}
                          panelClassName='!tw-text-sm'
                          onChange={({ value }: { value: string }) => {
                            const impuestoSeleted = impuestosEmpresa
                              ?.flatMap((taxe) => taxe.items)
                              ?.find(
                                (tax?: GetAllImpuestosDtoProps) =>
                                  tax?.id === value
                              )
                            setFieldValue(
                              `lineasImpuesto[${index}].categoria`,
                              impuestoSeleted?.grupo.tipo
                            )
                            setFieldValue(
                              `lineasImpuesto[${index}].porcentajeImpuesto`,
                              impuestoSeleted?.valor,
                              Boolean(
                                errors?.lineasImpuesto?.[index]
                                  ?.porcentajeImpuesto
                              )
                            )
                            setFieldValue(
                              `lineasImpuesto[${index}].claveImpuesto`,
                              impuestoSeleted?.clave
                            )
                            if (impuestoSeleted?.valor !== undefined) {
                              setFieldValue(
                                `lineasImpuesto[${index}].valorImpuesto`,
                                (impuestoSeleted?.valor / 100) *
                                  (impuesto.subtotal ?? 0)
                              )
                            }
                          }}
                          loading={impuestosEmpresaIsLoading}
                          value={
                            impuestosEmpresa
                              ?.flatMap((taxe) => taxe.items)
                              ?.find((tax?: GetAllImpuestosDtoProps) => {
                                return tax?.clave === impuesto.claveImpuesto
                              })?.id ??
                            impuestosEmpresa
                              ?.flatMap((taxe) => taxe.items)
                              ?.find((tax?: GetAllImpuestosDtoProps) => {
                                return (
                                  tax?.valor === impuesto.porcentajeImpuesto
                                )
                              })?.id ??
                            undefined
                          }
                          key={`${impuesto.id}-porcentajeImpuesto`}
                          optionLabel='nombre'
                          optionGroupLabel='label'
                          optionGroupChildren='items'
                          optionValue='id'
                        />
                      </div>
                      <div className='tw-h-10'>
                        <DropdownCuentasAsientos
                          options={
                            SHOW_TAXES_COMPRAS.includes(values.tipoAsiento)
                              ? cuentasCompras
                              : cuentasVenta
                          }
                          onChange={({ value }: { value: string }) =>
                            setFieldValue(
                              `lineasImpuesto[${index}].cuentaContableId`,
                              value,
                              Boolean(
                                errors?.lineasImpuesto?.[index]
                                  ?.cuentaContableId
                              )
                            )
                          }
                          className={`!tw-border-neutral-25 ${
                            errors?.lineasImpuesto?.[index]?.cuentaContableId
                              ? "!tw-border-danger"
                              : ""
                          } !tw-text-sm hover:!tw-border-neutral-75`}
                          id={`${impuesto.id}-cuentaContableId`}
                          loading={
                            SHOW_TAXES_COMPRAS.includes(values.tipoAsiento)
                              ? cuentasComprasIsLoading
                              : cuentasVentaIsLoading
                          }
                          value={impuesto.cuentaContableId}
                          refreshFetchData={
                            SHOW_TAXES_COMPRAS.includes(values.tipoAsiento)
                              ? cuentasComprasRefetch
                              : cuentasVentaRefetch
                          }
                          listaDeCuentasBase={
                            SHOW_TAXES_COMPRAS.includes(values.tipoAsiento)
                              ? cuentasComprasBase
                              : cuentasVentaBase
                          }
                          withCreateCuenta
                        />
                      </div>
                      <div className='tw-h-10'>
                        <InputCurrency
                          value={impuesto.subtotal ?? undefined}
                          placeholder='0,00'
                          className={`!tw-h-10 ${
                            errors?.lineasImpuesto?.[index]?.subtotal
                              ? "!tw-border-danger"
                              : ""
                          } !tw-text-sm`}
                          onChange={(value: number | undefined) => {
                            setFieldValue(
                              `lineasImpuesto[${index}].subtotal`,
                              Number.isNaN(value) ? null : value,
                              Boolean(errors?.lineasImpuesto?.[index]?.subtotal)
                            )

                            if (
                              impuesto?.porcentajeImpuesto !== null &&
                              value !== undefined
                            ) {
                              setFieldValue(
                                `lineasImpuesto[${index}].valorImpuesto`,

                                Number.isNaN(value)
                                  ? null
                                  : (impuesto?.porcentajeImpuesto / 100) * value
                              )
                            }
                          }}
                        />
                      </div>
                      <div className='tw-h-10 tw-flex tw-flex-row tw-items-center'>
                        <InputCurrency
                          value={impuesto.valorImpuesto}
                          placeholder='0,00'
                          className='!tw-h-10 !tw-text-sm'
                          disabled
                        />
                        <Button
                          className='tw-h-full tw-w-10 tw-px-1 tw-flex tw-items-center tw-cursor-pointer tw-mr-1 tw-ml-5 !tw-border-none !tw-shadow-none tw-justify-center'
                          onClick={() => {
                            remove(index)
                            values.lineasImpuesto.length === 1 &&
                              push({
                                id: uuidv4(),
                                categoria: IMPUESTO_CATEGORIA.IVA,
                                claveImpuesto: undefined,
                                porcentajeImpuesto: null,
                                cuentaContableId: undefined,
                                subtotal: null,
                                valorImpuesto: null,
                              })
                          }}
                        >
                          <FontAwesomeIcon
                            icon={["fal", "trash-can"]}
                            className='tw-text-danger tw-h-5'
                          />
                        </Button>
                      </div>
                    </div>
                  )
                )}
              </div>
              <div className='tw-w-full tw-flex tw-justify-center tw-flex-grow-0'>
                <Button
                  className='tw-flex tw-flex-row tw-gap-3 tw-items-center tw-pl-2 tw-pr-4 hover:!tw-border-neutral-50 hover:!tw-text-text tw-bg-white tw-shadow tw-rounded tw-my-4 tw-h-10 tw-cursor-pointer hover:tw-shadow-md'
                  onClick={() =>
                    push({
                      id: uuidv4(),
                      categoria: IMPUESTO_CATEGORIA.IVA,
                      cuentaContableId: undefined,
                      claveImpuesto: undefined,
                      porcentajeImpuesto: null,
                      subtotal: null,
                      valorImpuesto: null,
                    })
                  }
                >
                  <FontAwesomeIcon
                    icon={["fal", "plus"]}
                    className='tw-text-text tw-w-4 tw-h-4'
                  />
                  <span className='tw-text-sm'>
                    {t("diario.modal.addAccountTaxe")}
                  </span>
                </Button>
              </div>
            </div>
          )
        }}
      </FieldArray>
    </div>
  )
}

export default LineasImpuestosAsientosContable
